import store from '@/store'
import clientCommissionCreate from './../components/clientCommissionCreate.vue'
export default {
  className: 'clientCommission',
  fields: [
    {
      // 所属客户
      name: 'Client',
      note: '客户',
      validators: [
        (val) => val ? null : '所属客户不可为空'
      ],
      listWhere: (where) => {
        if (store.state.user && store.state.user.allClient === 'No') {
          where.userid = store.state.user.objectId
        }
      }
    },
    {
      // 成品型号
      name: 'finishProduct',
      note: '成品型号',
      validators: [
        (val) => val ? null : '成品型号不可为空'
      ]
    },
    {
      // 提成
      name: 'clientCommission',
      note: '提成',
      validators: [
        (val) => val ? null : '客户提成不可为空',
        (val) => val >= 0 ? null : '请输入正确的数字'
      ]
    }
  ],
  action: {
    create: store.state.user && store.state.user.authority.clientCommission.create
      ? {
        text: '新建',
        title: '添加客户提成',
        component: clientCommissionCreate
      } : false,
    edit: store.state.user && store.state.user.authority.clientCommission.edit ? {} : false,
    delete: store.state.user && store.state.user.authority.clientCommission.del ? {} : false
  },
  hooks: {
    beforeInsert ({ data }) {
      data.userid = store.state.user.objectId
    },
    beforeFetch ({ where }) {
      // if (store.state.user && store.state.user.adminRole === 'sale') {
      // where.userid = store.state.user.objectId
      // }
      if (store.state.user && store.state.user.allClient === 'Yes') { } else {
        where.userid = store.state.user.objectId
      }
    }
  }
}
